let common = {
    error: "应用不存在，请检查应用链接是否正确",
  code501:"访问权限限制",
    spin: {
      	text: "加载中..."
    },
	push: {
		text: "推送",
		sendCode: "发送验证码"
	},
	code: {
		get: "获取验证码",
		emailCodePlaceholder: "请输入邮箱验证码",
		msg6: "请输入6位数字的验证码",
		phoneCodePlaceholder: "请输入短信验证码",
	},
	btn: {
		submit: "确定",
		search: "搜索",
		reset: "重置",
		read: "批量已读",
		edit: "修改",
		subBtn: "保存",
		close: "取消",
		closeBtn: "关闭",
		loading:"加载中.....",
		commit:"提交",
	},
	pwd: {
		affirmPassword: "请输入确认密码",
		verifyPassword: "两次输入的密码不一致",
		newPwd: "请输入新密码",
	},
	browser: {
		errorAuthentication: "您的浏览器暂不支持此认证方式！",
		arouse: "已经唤起认证器！",
		overtime: "用户取消操作或操作超时！",
		noWeb: "这个浏览嚣不支持Web认证！",
		secureConnection: "Web认证仅支持安全连接",
		authenticationMethod: "请选择认证方式！",
		FIDO2Look: "FIDO2认证登录失败：认证器已锁定",
		FIDO2Err: "FIDO2认证登录失败：认证器未启用",
		nonsupport: "您的浏览器暂不支持绑定令牌！"
	},
	pagination: {
		from: "从",
		to: "到",
		aggregate: "总计",
		strip: "条",
		perPage:"每页数目",
	},
	tailorImg: {
		title: "头像上传",
		uploadText: "选择图片",
		typeErr: "请上传JPG、PNG图片!",
		sizeErr: "图片不能大于200kb!",
		noFile: "请选择图片！"
	},
	header: {
		goOut: "退出登录",
		modalTitle: "会话即将超时提醒",
		okText: "继续使用",
		countdown: "当前剩余会话时长",
		notification: "消息通知",
		tip1: "您有",
		tip2: "条消息未查看",
	}
}

export default common
